import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import React, { useState } from "react";
import * as styles from "/src/components/Header.module.css";
import { FaBars } from "@react-icons/all-files/fa/FaBars";
import { FiSearch } from "@react-icons/all-files/fi/FiSearch";
import Sidebar from "/src/components/Sidebar";
import { v4 as uuidv4 } from "uuid";

export default function Header() {
  const [viewSidebar, setViewSidebar] = useState(false);

  const toggleSidebar = () => {
    setViewSidebar(!viewSidebar);
    document.body.classList.toggle("noscroll");
  };
  const links = [
    { page: "About", to: "/about" },
    { page: "Projects", to: "/projects" },
    { page: "Resources", to: "/resources" },
    { page: "Blog", to: "/blog" },
    { page: "EcoChamps", to: "/ecochamps" },
    { page: "Contact", to: "/contact" },
  ];
  return (
    <>
      <nav className={styles.headerContainer}>
        <Link to="/">
          <StaticImage
            layout="constrained"
            width={250}
            style={{ minWidth: 200 }}
            src="../images/magorium_logo.png"
            alt="Mgorium Logo"
          />
        </Link>
        <div className={styles.linksContainer}>
          {links.map((entry) => (
            <Link key={uuidv4()} className={styles.navLink} to={entry.to}>
              {entry.page}
            </Link>
          ))}
          <Link to="/search">
            <FiSearch fontSize={25} className={styles.searchIcon} />
          </Link>
          <Link className={styles.navLink} to="/volunteer">
            <div className={styles.btn}>Sign Up</div>
          </Link>
          <div className={styles.mobileIcon}>
            <FaBars onClick={toggleSidebar} />
          </div>
        </div>
      </nav>
      <Sidebar isVisible={viewSidebar} onPress={toggleSidebar} />
    </>
  );
}
